import { useEffect, useState } from 'react';
import { useDeviceSelectors, useMobileOrientation } from 'react-device-detect';
import useWindowResizeHandler from '@src/shared/hooks/use-window-resize-handler';
import { breakpointsValue } from '@src/themes/JETTheme';
export default function () {
  const [browserUA, setBrowserUA] = useState(window.navigator.userAgent);
  const [selectors] = useDeviceSelectors(browserUA);
  const { isLandscape } = useMobileOrientation();
  const { isMobile, isTablet, isIOS, isAndroid } = selectors;
  const isMobileDevice = isMobile && !isTablet;
  const { isWindowResizing } = useWindowResizeHandler();
  const [isResolutionMobile, setIsResolutionMobile] = useState(false);
  const [viewPortHeight, setViewPortHeight] = useState(0);

  const getPortraitWidth = () => {
    const orientation = screen.orientation || screen.mozOrientation || screen.msOrientation;

    if (orientation) {
      if (orientation.type && orientation.type.includes('portrait')) {
        return window.screen.width;
      } else {
        return window.screen.height;
      }
    } else {
      return window.screen.width;
    }
  };

  const isTabletCertainCheck = (() => {
    if (isTablet && getPortraitWidth() > 720) {
      return true;
    } else if ('ontouchstart' in window && getPortraitWidth() > 720) {
      return true;
    } else {
      return false;
    }
  })();

  const isResolutionMobileInstantCheck = () => {
    if (document.body.clientWidth < breakpointsValue.values.md && document.body.clientWidth >= 0) {
      return true;
    } else {
      return false;
    }
  };
  const checkResolution = () => {
    if (document.body.clientWidth < breakpointsValue.values.md && document.body.clientWidth >= 0) {
      setIsResolutionMobile(true);
    } else {
      setIsResolutionMobile(false);
    }
    setViewPortHeight(document.body.clientHeight);
  };
  useEffect(() => {
    if (!isWindowResizing) {
      setBrowserUA(window.navigator.userAgent);
    }

    checkResolution();
  }, [isWindowResizing, isLandscape]);

  useEffect(() => {
    if (!screen.orientation) {
      return;
    }
    screen.orientation.addEventListener('change', (event) => {
      setTimeout(() => {
        checkResolution();
      }, 100);
    });
    return () => {
      screen.orientation.removeEventListener('change', (event) => {
        setTimeout(() => {
          checkResolution();
        }, 100);
      });
    };
  }, []);

  useEffect(() => {
    checkResolution();
  }, []);

  return {
    isMobileDevice,
    isResolutionMobile,
    isResolutionMobileInstantCheck,
    isTablet: isTabletCertainCheck,
    isWindowResizing,
    isAndroid,
    isIOS,
    viewPortHeight,
  };
}
